//Diagram Content Script
jQuery(function($){
    
    if( typeof(DiagramContentItems) !== 'undefined' ){
        buildDiagramPearls(DiagramContentItems);
        initDiagramContent(DiagramContentItems);

        // Web fonts change text metrics: rebuild so labels wrap correctly
        if( document.fonts && document.fonts.ready ){
            document.fonts.ready.then(function(){ buildDiagramPearls(DiagramContentItems); });
        }
    }

    var prevPelletID = '';
    var nextPelletID = '';
    var currentURL = window.location.href;
    currentURL = currentURL.split('?')[0];
    if( typeof(CommentFormURL) !== 'undefined' ){
        var commentURL = CommentFormURL + '?origine=' + currentURL;
    }else{
        var commentURL = null;
    }

    /**
     * Builds the pearls from the ACF items along the <path class="diagram-path"> of the SVG.
     * Path options (data attributes): data-label-side (outward|inward|above|below), data-start (0-1, closed paths),
     * data-center ("x,y"), data-pearl-radius, data-font-size, data-label-gap, data-label-width, data-default-color.
     * SVG without .diagram-path keep their own hand-made #links.
     */
    function buildDiagramPearls(ContentItems){

        var SVG_NS = 'http://www.w3.org/2000/svg';
        var ids = Object.keys(ContentItems);

        $('.diagram-container svg').each(function(){

            var svg = this;
            var path = svg.querySelector('path.diagram-path');
            if( !path || !ids.length ){
                return;
            }

            function option(name, fallback){
                var value = parseFloat(path.getAttribute('data-' + name));
                return isNaN(value) ? fallback : value;
            }

            var radius = option('pearl-radius', 30.5);
            var fontSize = option('font-size', 16);
            var gap = option('label-gap', 12);
            var maxWidth = option('label-width', 180);
            var start = option('start', 0);
            var side = path.getAttribute('data-label-side') || 'outward';
            var defaultColor = path.getAttribute('data-default-color') || 'red';
            var lineHeight = fontSize * 1.2;

            var total = path.getTotalLength();
            var closed = /z\s*$/i.test( (path.getAttribute('d') || '').trim() );
            var toSvg = pathToSvgMatrix(svg, path);

            function toPoint(p){
                var pt = svg.createSVGPoint();
                pt.x = p.x;
                pt.y = p.y;
                return pt.matrixTransform(toSvg);
            }

            var center;
            var centerAttr = (path.getAttribute('data-center') || '').split(',');
            if( centerAttr.length === 2 && !isNaN(parseFloat(centerAttr[0])) && !isNaN(parseFloat(centerAttr[1])) ){
                center = { x: parseFloat(centerAttr[0]), y: parseFloat(centerAttr[1]) };
            }else{
                var box = path.getBBox();
                center = toPoint({ x: box.x + box.width / 2, y: box.y + box.height / 2 });
            }

            // Removes previous pearls (hand-made or from a previous build)
            $(svg).find('#links').remove();
            var links = document.createElementNS(SVG_NS, 'g');
            links.setAttribute('id', 'links');
            svg.appendChild(links);

            var count = ids.length;

            $.each(ids, function(index, id){

                var item = ContentItems[id];

                // Closed path : equal gaps all around. Open path : first and last pearls on the path ends.
                var fraction;
                if( closed ){
                    fraction = ((start + index / count) % 1 + 1) % 1;
                }else{
                    fraction = count > 1 ? index / (count - 1) : 0.5;
                }
                var length = fraction * total;

                var point = toPoint( path.getPointAtLength(length) );
                var before = toPoint( path.getPointAtLength(Math.max(length - 1, 0)) );
                var after = toPoint( path.getPointAtLength(Math.min(length + 1, total)) );
                var tangent = normalize({ x: after.x - before.x, y: after.y - before.y });

                var direction = labelDirection(point, tangent, center, side);

                var group = document.createElementNS(SVG_NS, 'g');
                group.setAttribute('id', id);
                group.setAttribute('class', 'diagram-pearl pearl-' + (item.category_color || defaultColor));
                group.setAttribute('role', 'button');
                group.setAttribute('tabindex', '0');
                group.setAttribute('aria-label', item.title || '');

                var circle = document.createElementNS(SVG_NS, 'circle');
                circle.setAttribute('cx', point.x.toFixed(2));
                circle.setAttribute('cy', point.y.toFixed(2));
                circle.setAttribute('r', radius);
                group.appendChild(circle);

                var text = document.createElementNS(SVG_NS, 'text');
                text.setAttribute('font-size', fontSize);
                group.appendChild(text);
                links.appendChild(group);

                var lines = wrapText(text, item.title || '', maxWidth, fontSize);
                var blockHeight = lines.length * lineHeight;
                var offset = radius + gap;
                var anchorX = point.x + direction.x * offset;
                var anchorY = point.y + direction.y * offset;

                // Lines are centered; side labels are shifted so the block sits beside the pearl
                if( Math.abs(direction.x) >= 0.35 ){
                    anchorX += (direction.x > 0 ? 1 : -1) * lines.width / 2;
                }

                var top;
                if( direction.y < -0.5 ){
                    top = anchorY - blockHeight;
                }else if( direction.y > 0.5 ){
                    top = anchorY;
                }else{
                    top = anchorY - blockHeight / 2;
                }

                text.setAttribute('text-anchor', 'middle');

                $.each(lines, function(lineIndex, line){
                    var tspan = document.createElementNS(SVG_NS, 'tspan');
                    tspan.setAttribute('x', anchorX.toFixed(2));
                    tspan.setAttribute('y', (top + fontSize * 0.9 + lineIndex * lineHeight).toFixed(2));
                    tspan.textContent = line;
                    text.appendChild(tspan);
                });
            });
        });
    }

    function normalize(vector){
        var length = Math.sqrt(vector.x * vector.x + vector.y * vector.y) || 1;
        return { x: vector.x / length, y: vector.y / length };
    }

    // Unit vector from the pearl towards where its label goes
    function labelDirection(point, tangent, center, side){

        var outward = normalize({ x: point.x - center.x, y: point.y - center.y });

        if( side === 'inward' ){
            return { x: -outward.x, y: -outward.y };
        }

        if( side === 'above' || side === 'below' ){
            // Where the path runs vertically, labels go to the side instead
            if( Math.abs(tangent.y) > 0.7 ){
                return { x: point.x >= center.x ? 1 : -1, y: 0 };
            }
            return { x: 0, y: side === 'above' ? -1 : 1 };
        }

        return outward;
    }

    // Matrix converting the path coordinates (with its transforms) to the root SVG coordinates
    function pathToSvgMatrix(svg, path){
        var svgMatrix = svg.getScreenCTM();
        var pathMatrix = path.getScreenCTM();
        return (svgMatrix && pathMatrix) ? svgMatrix.inverse().multiply(pathMatrix) : svg.createSVGMatrix();
    }

    // Splits a title into lines fitting maxWidth. Returns the lines, with the widest line width in .width
    function wrapText(textElement, title, maxWidth, fontSize){

        function measure(value){
            textElement.textContent = value;
            var width = textElement.getComputedTextLength ? textElement.getComputedTextLength() : 0;
            return width || value.length * fontSize * 0.55;
        }

        var words = $.trim(title).split(/\s+/);
        var lines = [];
        var current = '';

        $.each(words, function(i, word){
            var candidate = current ? current + ' ' + word : word;
            if( current && measure(candidate) > maxWidth ){
                lines.push(current);
                current = word;
            }else{
                current = candidate;
            }
        });
        lines.push(current);

        lines.width = 0;
        $.each(lines, function(i, line){
            lines.width = Math.max(lines.width, measure(line));
        });

        textElement.textContent = '';
        return lines;
    }

    function initDiagramContent(ContentItems){
        
        var ids = Object.keys(ContentItems);

        $('.diagram-container').on('click', 'svg #links > g', function(event){

            var pellet = event.currentTarget;
            var pelletID = $(pellet).attr('id');
            var curr = ids.indexOf(pelletID);
            
            prevPelletID = curr > 0 ? ids[curr - 1] : undefined;
            nextPelletID = curr < ids.length - 1 ? ids[curr + 1] : undefined;

            if( typeof(ContentItems[pelletID]) !== 'undefined' ){

                console.log("ContentItems[pelletID]", ContentItems[pelletID]);

                //Update Modal content
                $('#DiagramContentModal .modalitem-title').html( ContentItems[pelletID]['title'] );
                $('#DiagramContentModal .modalitem-content').html( ContentItems[pelletID]['content'] );
                if(commentURL){
                    $('#DiagramContentModal .modalitem-comment a').attr( 'href', commentURL + "&section=" + ContentItems[pelletID]['title'] );
                }

                if( ContentItems[pelletID]['category_name'] ){
                    $('#DiagramContentModal .modalitem-category').text( ContentItems[pelletID]['category_name'] );
                    $('#DiagramContentModal .modalitem-icon').html( '<img src="'+ ContentItems[pelletID]['category_icon'] + '" />' );
                    $('#DiagramContentModal .diagram-modalitem-header')[0].className = $('#DiagramContentModal .diagram-modalitem-header')[0].className.replace(/\bbg-.*?\b/g, '');
                    $('#DiagramContentModal .diagram-modalitem-header').addClass( 'bg-' + ContentItems[pelletID]['category_color'] );
                }else{
                    $('#DiagramContentModal .modalitem-category').text( '' );
                    $('#DiagramContentModal .modalitem-icon').html( '' );
                    $('#DiagramContentModal .diagram-modalitem-header')[0].className = $('#DiagramContentModal .diagram-modalitem-header')[0].className.replace(/\bbg-.*?\b/g, '');
                }


                //Open Modal
                $('#DiagramContentModal').modal('show');
                
                // Adds and manages nav buttons
                if(prevPelletID){
                    $('.prev-modal-item').css('display', 'inline-block');
                    $('.prev-modal-item').attr('data-prev-pellet', prevPelletID)
                } else {
                    $('.prev-modal-item').css('display', 'none');
                }
                
                if(nextPelletID){
                    $('.next-modal-item').css('display', 'inline-block');
                    $('.next-modal-item').attr('data-next-pellet', nextPelletID)
                } else {
                    $('.next-modal-item').css('display', 'none')
                }

            }

        });

    }

    $('.diagram-container').on('keydown', 'svg #links > g', function(event){
        if( event.key === 'Enter' || event.key === ' ' ){
            event.preventDefault();
            $(this).click();
        }
    });

    $('.diagram-nav-btn.prev-modal-item').on('click', function(){
        $('svg #links > g#' + prevPelletID ).click();

        $('#DiagramContentModal .diagram-modalitem-header').removeClass( 'blue' );
        $('#DiagramContentModal .diagram-modalitem-header').removeClass( 'red' );
        $('#DiagramContentModal .diagram-modalitem-header').removeClass( 'green' );
    });
    $('.diagram-nav-btn.next-modal-item').on('click', function(){
        $('svg #links > g#' + nextPelletID ).click();

        $('#DiagramContentModal .diagram-modalitem-header').removeClass( 'blue' );
        $('#DiagramContentModal .diagram-modalitem-header').removeClass( 'red' );
        $('#DiagramContentModal .diagram-modalitem-header').removeClass( 'green' );
    });

    //Open Diagram Info in Popover
    function triggerDiagramPopover(elem, action){
        console.log('in popover');
        var popoverID = $(elem).attr('id');
        popoverID = popoverID.replace('i', '');
        popoverID = popoverID.replace('l', '');
        var popoverContent = $(elem).closest('svg').find('#popover #p'+popoverID);
        
        if( !popoverContent ){
            return;
        }
        
        if( action == 'show' ){
            $(popoverContent).show();
        }else{
            setTimeout(function(){
                $(popoverContent).hide();
            }, 500);
        }
    }

    //Listner :
    $('body').on('mouseenter', '.diagram-container svg #infos g[id^=i]', function(){
        triggerDiagramPopover(this, 'show');
    }).on('mouseleave', '.diagram-container svg #infos g[id^=i]', function(){
        triggerDiagramPopover(this, 'hide');
    });

    $('body').on('mouseenter', '.diagram-container svg #links g[id^=l]', function(){
        triggerDiagramPopover(this, 'show');
    }).on('mouseleave', '.diagram-container svg #links g[id^=l]', function(){
        triggerDiagramPopover(this, 'hide');
    });
        

    //Show diagram in full size
    $('body').on('click', '.diagram-fullsize', function(elem){

        $('button.diagram-fullsize').toggleClass('btn-dark');
        $('button.diagram-fullsize').toggleClass('btn-outline-primary');
        $('.diagram-container').toggleClass('full-size');

        if( $('button.diagram-fullsize').hasClass('btn-dark') ){
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".diagram-container").offset().top
            }, 200);
        }

    });
});